export const ErrorToast = ({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss: () => void;
}) => {
  return (
    <div
      className="flex items-center bg-red-500 hover:bg-red-600 rounded text-white text-sm font-bold px-4 py-3 mb-6 cursor-pointer"
      role="alert"
      onClick={onDismiss}
    >
      <i className="fa fa-times mr-4" />
      <div>
        <p>Er is iets misgegaan</p>
        <p>Foutcode: {message}</p>
      </div>
    </div>
  );
};
